import script from "./ExportSpecificFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportSpecificFile.vue?vue&type=script&lang=ts&setup=true"

import "./ExportSpecificFile.vue?vue&type=style&index=0&id=e2b465d2&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2b465d2"]])

export default __exports__